<template>
  <b-input
    type="text"
    size="sm"
    class="form-control"
    :placeholder="placeholder"
    v-bind:value="val"
    :name="name"
    @input="val => _onInput(val)"
    @change="val => _onChange(val)"
    :maxlength="10"
    :state="state"
    :size="size"
  ></b-input>
</template>
<script>
import countries from "../../data/countries.js";

export default {
  props: {
    "v-validate": {
      default: ""
    },
    formatZip: {
      default: true
    },
    name: {
      default: ""
    },
    placeholder: {
      default: ""
    },
    value: {
      required: true
    },
    state: {
      default: null
    },
    size: {
      default: "md"
    },
  },
  data() {
    return {};
  },
  computed: {
    val() {
      return this.format(this.value);
    }
  },
  watch: {
    value() {
      this.$forceUpdate();
    }
  },
  created() {},
  methods: {
    _onInput(val) {
      val = this.format(val);
      this.$emit("input", val);
    },
    _onChange(val) {
      val = this.format(val);
      this.$emit("change", val);
    },
    format(val) {
      if(!val || !this.formatZip) return val;

      // Strip non-numeric
      val = val.replace(/\D/g, "").toString();

      // Hyphenate if necessary
      if (val.length > 5) {
        val = val.substr(0, 5) + "-" + val.substr(5);
        val = val.substr(0, 10);
      }
      return val;
    },
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Form/ZipCode.vue